  <button 
    type="button"
    [matTooltip]="content"
    [matTooltipPosition]="placement"
    class="button--tooltip"
  >{{tooltipSymbol[type]}}</button>
